import { FUTURE, PAST_YEAR, PRESENT } from 'timeline/enums/constants';

export const parseSeasonYear = (season) => {
  return season && typeof season === 'string' ? season?.split(' ')?.[1] : null;
};

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const getYear = ({
  season,
  releaseDate,
  releaseDateYear,
  releaseYear,
  seasonYear,
  seasonType,
  timelineData = {},
}: any) => {
  const { isTimelinePath, timelineType } = timelineData;

  if (seasonType && seasonYear && seasonYear.length > 0 && !isTimelinePath) return seasonYear;

  if (season && !isTimelinePath) {
    return parseSeasonYear(season);
  }

  if (releaseDate?.seconds) {
    const date = new Date(releaseDate.seconds * 1000);
    // Timeline
    if (isTimelinePath) {
      if (timelineType === FUTURE || timelineType === PRESENT) {
        return `${months[date.getMonth()]} ${date.getDate()} ${date.getFullYear()}`;
      }
      if (timelineType === PAST_YEAR) {
        return `${months[date.getMonth()]} ${date.getDate()}`;
      }
    }

    // General
    const isCurrentYear = date.getFullYear() === new Date().getFullYear();
    return isCurrentYear
      ? date.toLocaleDateString('en-US', {
          month: 'short',
          day: '2-digit',
        })
      : date.getFullYear()?.toString();
  }

  if (releaseYear && releaseYear.length > 0) return releaseYear;

  if (releaseDateYear && releaseDateYear.length > 0) return releaseDateYear;

  const rel = typeof releaseDate !== 'undefined' && releaseDate.toString();
  if (releaseDate) {
    return rel.slice(0, 4);
  }

  return null;
};
